require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#1DBF73',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        white: '#FFFFFF',
      },
      dark: {
        primary: '#1DBF73',
        accent: '#0d6efd',
        secondary: '#8A8D93',
        success: '#56CA00',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
        white: '#FFFFFF',
      },
    },
  },
}
